import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { BillingItemSettingsDTO } from 'src/app/demo/model/BillingItemSettingsDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
// import { WebStorage } from '../../../auth/storage/web.storage';

@Component({
    selector: 'app-bill-item-setting',
    templateUrl: './bill-item-setting.component.html',
    styleUrls: ['./bill-item-setting.component.scss'],
})
export class BillItemSettingComponent implements OnInit {
    presetItemList: BillingItemSettingsDTO[] = [];
    discountItemList: BillingItemSettingsDTO[] = [];
    settingData: any;
    isAddClicked: boolean = false;
    schoolId!: number;
    constructor(
        public config: DynamicDialogConfig,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        private operationService: OperationService,
        private lookupService: LookupService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private storage: WebStorage
    ) {
        this.settingData = this.config;
        this.schoolId = this.storage.getCompanyId();
    }

    // schoolId is set in the constructor

    ngOnInit() {
        if (this.settingData.header === 'Manage Presets') {
            this.queryData('Manage Presets');
        } else {
            this.queryData('Manage Discount');
        }
        this.presetItemList = [];
        this.discountItemList = [];
    }

    queryData(header: string) {
        this.lookupService
            .queryBillingItemSetting({
                'schoolId.equals': this.schoolId,
                'isPresetItem.equals':
                    header == 'Manage Presets' ? true : false,
                'status.equals': 'A',
            })
            .subscribe((res: HttpResponse<BillingItemSettingsDTO[]>) => {
                this.presetItemList = res.body ?? [];
            });
    }

    onRowEditInit() {}

    onRowEditSave(item: any) {
        this.isAddClicked = false;
        const isUpdate = item.id !== undefined;
        const serviceMethod = isUpdate
            ? 'updateBillItemSetting'
            : 'createBillItemSetting';

        item.schoolId = this.schoolId;
        item.status = 'A';
        if (this.settingData.header === 'Manage Presets') {
            item.isPresetItem = true;
            item.isDiscount = false;
            if (item && item.name && item.rate) {
                this.operationService[serviceMethod](item).subscribe(
                    (res: HttpResponse<BillingItemSettingsDTO>) => {
                        this.messageService.add({
                            key: 'item',
                            severity: 'success',
                            summary: 'Success',
                            detail: `Preset ${
                                isUpdate ? 'Updated' : 'Created'
                            } successfully.`,
                            life: 3000,
                        });
                        this.queryData('Manage Presets');
                    },
                    (error) => {
                        this.messageService.add({
                            severity: 'error',
                            life: 3000,
                            summary: error.error?.title || 'Error',
                            detail: error.error?.detail || error.error?.message || error?.message || 'Failed to save'
                        });
                    }
                );
            }
        } else {
            // Discount mode: send required payload with all BillingItemSettingsDTO properties
            const discountPayload: BillingItemSettingsDTO = {
                id: item.id ?? undefined,
                name: item.name,
                rate: item.rate ?? 0,
                status: 'A',
                isPresetItem: false,
                isDiscount: true,
                schoolId: this.schoolId,
                lastModified: new Date().toISOString(),
                lastModifiedBy: this.storage.getUsername?.() || 'system',
            };
            this.operationService
                .createBillItemSetting(discountPayload)
                .subscribe(
                    (res: HttpResponse<BillingItemSettingsDTO>) => {
                        this.messageService.add({
                            key: 'item',
                            severity: 'success',
                            summary: 'Success',
                            detail: `Discount Created successfully.`,
                            life: 3000,
                        });
                        this.queryData('Manage Discount');
                    },
                    (error) => {
                        this.messageService.add({
                            severity: 'error',
                            life: 3000,
                            summary: error.error?.title || 'Error',
                            detail: error.error?.detail || error.error?.message || error?.message || 'Failed to save'
                        });
                    }
                );
        }
    }
    onRowEditCancel(item: BillingItemSettingsDTO, index: number) {
        this.isAddClicked = false;
        if (item.id != undefined) {
            this.queryData(
                `Manage ${item?.isPresetItem == true ? 'Presets' : 'Discount'}`
            );
        } else {
            this.presetItemList.splice(index, 1);
        }
    }

    onRowEditDelete(item: BillingItemSettingsDTO, index: number, event: Event) {
        this.isAddClicked = false;

        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: `Do you want to delete this ${
                this.settingData.header === 'Manage Presets'
                    ? 'Preset'
                    : 'Discount'
            } Item?`,
            header: `Delete ${
                this.settingData.header === 'Manage Presets'
                    ? 'Preset'
                    : 'Discount'
            } Item`,
            acceptLabel: 'Delete',
            rejectLabel: 'No',
            acceptIcon: '',
            rejectIcon: '',
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-outlined p-button-primary',
            defaultFocus: 'none',
            accept: () => this.deleteDose(item, index),
            reject: () => {},
        });
    }

    deleteDose(item: any, index: number) {
        if (item.id != undefined) {
            item.status = 'I';
            this.operationService.updateBillItemSetting(item).subscribe(
                (res: HttpResponse<BillingItemSettingsDTO>) => {
                    this.messageService.add({
                        key: 'item',
                        severity: 'success',
                        summary: 'Success',
                        detail: `${
                            res.body?.isPresetItem == true
                                ? 'Preset'
                                : 'Discount'
                        } Deleted successfully.`,
                        life: 3000,
                    });
                    this.queryData(
                        `Manage ${
                            res.body?.isPresetItem == true
                                ? 'Presets'
                                : 'Discount'
                        }`
                    );
                },
                (error) => {
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
                            summary: error.error?.title || 'Error',
                            detail: error.error?.detail || error.error?.message || error?.message || 'Failed to save'
                    });
                }
            );
        } else {
            this.presetItemList.splice(index, 1);
        }
    }
    addPreset() {
        let obj: any = {};
        this.presetItemList.unshift(obj);
    }

    addDiscount() {
        let obj: any = {};
        this.presetItemList.unshift(obj);
    }
}